import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';
import { VideoAllEpisodes } from './index';
import '~/styles/main.scss';

global.React = React;
global.ReactDOM = ReactDOM;
global.ReactDOMServer = ReactDOMServer;

global.VideoAllEpisodes = VideoAllEpisodes;
// CLR alias: PortableComponent.cshtml renders VideosV2 blocks via this component.
global.VideosV2 = VideoAllEpisodes;
